import React from 'react';

export const SearchPrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4668 10.5333L14.4668 13.5333C14.7335 13.8 14.7335 14.2 14.4668 14.4666C14.3335 14.6 14.1335 14.6666 14.0002 14.6666C13.8668 14.6666 13.6668 14.6 13.5335 14.4666L10.5335 11.4666C9.5335 12.2 8.3335 12.6666 7.00016 12.6666C3.86683 12.6666 1.3335 10.1333 1.3335 6.99998C1.3335 3.86665 3.86683 1.33331 7.00016 1.33331C10.1335 1.33331 12.6668 3.86665 12.6668 6.99998C12.6668 8.33331 12.2002 9.59998 11.4668 10.5333ZM7.00016 2.66665C4.60016 2.66665 2.66683 4.59998 2.66683 6.99998C2.66683 9.39998 4.60016 11.3333 7.00016 11.3333C8.20016 11.3333 9.26683 10.8666 10.0668 10.0666C10.8668 9.26665 11.3335 8.19998 11.3335 6.99998C11.3335 4.59998 9.40016 2.66665 7.00016 2.66665Z"
        fill="#774EFF"
      />
    </svg>
  );
};
